"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../elements/elements/Simulator/constants");
const genStyle_1 = require("../genStyle");
const font_1 = require("../../font");
const theme_1 = require("../../theme");
const styleSchema = {
    image: {
        borderRadius: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderRadius }),
        borderStyle: (0, genStyle_1.genStyle)({ value: 'none' }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderColor }),
        borderWidth: (0, genStyle_1.genStyle)({ value: 1 }),
    },
    area: {
        backgroundColor: (0, genStyle_1.genStyle)({ value: '#E6E6E633' }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.focusedColor }),
    },
    textarea: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryBackgroundColor }),
        borderRadius: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderRadius }),
        borderStyle: (0, genStyle_1.genStyle)({ value: 'solid' }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderColor }),
        borderWidth: (0, genStyle_1.genStyle)({ value: 1 }),
    },
    hoverTextarea: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.hoverColor }),
    },
    focusTextarea: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryBackgroundColor }),
    },
    errorTextarea: {
        borderColor: (0, genStyle_1.genStyle)({ value: '#FF9FA1' }),
    },
    hint: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.neutralColor }),
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
    },
    navigation: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.primaryColor }),
    },
    hoverButton: {
        backgroundColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.hoverColor }),
    },
    icon: {
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.lightTextColor }),
    },
    backButton: {
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
    },
    nextButton: {
        backgroundImage: (0, genStyle_1.genStyle)({ value: null }),
    },
    indents: {
        gap: (0, genStyle_1.genStyle)({ value: 8 }),
        marginLeft: (0, genStyle_1.genStyle)({ value: 8 }),
        marginTop: (0, genStyle_1.genStyle)({ value: 8 }),
    },
    hover: {
        backgroundColor: (0, genStyle_1.genStyle)({ value: null }),
    },
    button_effects: {
        boxShadow: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.boxShadow }),
    },
    effects: {
        boxShadow: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.boxShadow }),
        animation: (0, genStyle_1.genStyle)({ value: true }),
    },
    textAreaEffects: {
        boxShadow: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.boxShadow }),
    },
};
const fontSchema = Object.assign({ navigation: Object.assign({}, font_1.FONT_SCHEMA_EMPTY.base), placeholder: Object.assign(Object.assign({}, font_1.FONT_SCHEMA_EMPTY.base), { color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.secondaryTextColor }) }) }, font_1.FONT_SCHEMA_EMPTY);
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: fontSchema, feedback: {} } };
